<div class="wrapper">
  <div class="search-wrapper">
    <vue-filter-search
      placeholder="{{ 'label.placeholder.searchClients' | translate | async }}"
      (searchValueChange)="updateSearchParams($event)"
      [inputValue]="initialSearchTerm"
    ></vue-filter-search>
  </div>
  <vue-filter-select
    ariaLabel="{{ 'label.aria.queue' | translate | async }}"
    [filter]="filters.queue"
    [format]="getQueueDisplay.bind(this)"
    [wideoverlay]="'wide-overlay'"
    (change)="filterChanged('queue', $event.value)"
  ></vue-filter-select>
</div>
